(async function initOptimizedFX() {
  // 1. Identify Context (Using the variables passed from theme.liquid)
  const templateName = window.AwakenConfig?.templateName || '';
  const urlParams = new URLSearchParams(window.location.search);
  const countryCode = urlParams.get('country') || window.AwakenConfig?.defaultCountry || 'IN';
  const cleanCountry = countryCode.toUpperCase();

  // Exit immediately for domestic users
  if (cleanCountry === 'IN') return; 

  // 2. Define Markets & Markups (US has 100% markup / 2.00)
  const countryMap = {
    US: { curr: 'USD', sym: '$', fallback: 84.0, markup: 2.00 }, 
    GB: { curr: 'GBP', sym: '£', fallback: 108.0, markup: 1.50 },
    CA: { curr: 'CAD', sym: 'C$', fallback: 62.0, markup: 1.50 },
    AU: { curr: 'AUD', sym: 'A$', fallback: 55.0, markup: 1.50 },
    AE: { curr: 'AED', sym: 'AED ', fallback: 23.0, markup: 1.50 },
    DE: { curr: 'EUR', sym: '€', fallback: 92.0, markup: 1.50 },
    SG: { curr: 'SGD', sym: 'S$', fallback: 64.0, markup: 1.50 },
    NZ: { curr: 'NZD', sym: 'NZ$', fallback: 51.0, markup: 2.50 }
  };

  const fxConfig = countryMap[cleanCountry] || { curr: 'USD', sym: '$', fallback: 84.0, markup: 1.00 };
  window.AwakenPricing = { 
    country: cleanCountry, 
    symbol: fxConfig.sym, 
    rate: fxConfig.fallback,
    markup: fxConfig.markup 
  };

  // 3. Fetch Live Rates (Cached)
  try {
    const now = Date.now();
    let rates = JSON.parse(localStorage.getItem('awaken_fx_rates'));
    const cacheTime = localStorage.getItem('awaken_fx_time');

    if (!rates || now - cacheTime > 43200000) {
      const res = await fetch('https://open.er-api.com/v6/latest/INR');
      const data = await res.json();
      rates = data.rates;
      localStorage.setItem('awaken_fx_rates', JSON.stringify(rates));
      localStorage.setItem('awaken_fx_time', now.toString());
    }
    if (rates && rates[fxConfig.curr]) window.AwakenPricing.rate = 1 / rates[fxConfig.curr];
  } catch (e) {
    console.warn('FX API offline, using fallback rate');
  }

  // 4. The Core Updater Function
  function updatePricesInDOM(container = document) {
    container
      .querySelectorAll('.aw-live-price:not([data-fx-applied]), .aw-global-price:not([data-fx-applied])')
      .forEach((el) => {
        const rawInr = parseFloat(el.getAttribute('data-raw-inr'));
        if (rawInr) {
          // Apply Live Rate AND Market Markup
          const finalConvertedPrice = (rawInr / window.AwakenPricing.rate) * window.AwakenPricing.markup;
          
          el.innerHTML = window.AwakenPricing.symbol + Math.round(finalConvertedPrice).toLocaleString('en-US');
          el.setAttribute('data-fx-applied', 'true');
        }
      });
  }

  // Expose to global scope so AJAX scripts can trigger it
  window.updateAwakenPricesInDOM = updatePricesInDOM;

  // 5. Run Initial Update (Check if DOM is ready since script is deferred)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => updatePricesInDOM());
  } else {
    updatePricesInDOM();
  }

  // 6. Page-Specific Event Hooks
  if (templateName === 'collection' || templateName === 'search') {
    const grid = document.querySelector('#product-grid, .pcs-grid');
    if (grid) {
      new MutationObserver(() => updatePricesInDOM(grid)).observe(grid, { childList: true, subtree: true });
    }
  }

  if (templateName === 'product') {
    document.addEventListener('variant:changed', () =>
      updatePricesInDOM(document.querySelector('.product__info-container'))
    );
  }

  // Universal Cart Hook
  document.addEventListener('theme:cart:change', () => {
    setTimeout(() => updatePricesInDOM(document.getElementById('custom-cart-drawer')), 100);
  });
})();